export class ClientModel {
    name: string;
    clientGuid: string;
    smsEnabled: boolean;
    smsNumber: string;
}